"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@chakra-ui/react");
var _excluded = ["color", "loaderBackgroundColor", "isInfinite", "size", "thickness", "trackColor", "value"];
var Loader = function Loader(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'success' : _ref$color,
    _ref$loaderBackground = _ref.loaderBackgroundColor,
    loaderBackgroundColor = _ref$loaderBackground === void 0 ? 'transparent' : _ref$loaderBackground,
    _ref$isInfinite = _ref.isInfinite,
    isInfinite = _ref$isInfinite === void 0 ? true : _ref$isInfinite,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 12 : _ref$size,
    _ref$thickness = _ref.thickness,
    thickness = _ref$thickness === void 0 ? 2 : _ref$thickness,
    _ref$trackColor = _ref.trackColor,
    trackColor = _ref$trackColor === void 0 ? 'gray.medium' : _ref$trackColor,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  /* -------------------------------------------------------------------- *\
      Note: Since most of the props for this component control multiple
      styles at a time, it was decided that it made the most sense to set
      up the default style-related properties here in lou of creating an
      overly complex styles file.
  \* -------------------------------------------------------------------- */
  var loaderDefaultProps = {
    color: color,
    isIndeterminate: isInfinite,
    size: size,
    thickness: thickness,
    trackColor: trackColor,
    value: value,
    capIsRound: true
  };
  return /*#__PURE__*/_react["default"].createElement(_react2.CircularProgress, (0, _extends2["default"])({
    sx: {
      '& svg > circle:first-of-type': {
        fill: loaderBackgroundColor
      }
    }
  }, loaderDefaultProps, props));
};
var _default = exports["default"] = Loader;